
import TranslateApi from "src/utils/TranslateHelper";

export class ColorChooserPopUp extends Phaser.GameObjects.Container {
    colors: number[] = [
        1,
        3,
        4,
        5,
        6,
        7,
        9,
        11
    ];

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, []);

        this.setDepth(10);
        this.setSize(380, 480);
        this.addBackground();
        this.addColors();

        this.scene.add.existing(this);
    }

    addBackground() {
        var background = this.scene.add.image(0, 0, "pixel");
        background.setDisplaySize(this.width, this.height);
        background.setTint(0x000000);
        background.setDepth(0);
        this.add(background);

        var style = { fontFamily: "Russo One, Arial", fontSize: 20, align: "center" };
        var title = this.scene.add.text(0, -215, TranslateApi.translate("UniformDesign.Phaser.popupTitle"), style);
        title.setOrigin(0.5);
        this.add(title);
    }

    addColors() {
        var squares = [];
        for (var color of this.colors) {
            var square = this.createColorSquare(color);
            this.add(square);
            squares.push(square);
        }

        Phaser.Actions.GridAlign(squares, {
            x: -60,
            y: -110,
            width: 2,
            height: -1,
            cellWidth: 120,
            cellHeight: 100,
        });
    }

    createColorSquare(color: number) {
        var square = this.scene.add.image(0, 0, "other", "color" + color);
        square.setDepth(1);
        square.setInteractive({ useHandCursor: true });
        square.on("pointerdown", () => {
            this.emit("choseColor", color);
        });
        return square;
    }
}




// WEBPACK FOOTER //
// ./src/games/UniformDesignGame/scenes/ColorChooserPopUp.ts